import { HttpInterceptorFn } from '@angular/common/http';
import { X_ACCOUNT_ID_KEY, X_AUTH_SESSION_KEY } from "../services/auth.service";
import { SKIP_SESSION_INTERCEPTOR } from "../http-context.tokens";


export const sessionInterceptor: HttpInterceptorFn = (request, next) => {
  // Если установлен флаг — пропустить sessionInterceptor
  if (request.context.get(SKIP_SESSION_INTERCEPTOR)) {
    return next(request);
  }

  const xAuthSession = localStorage.getItem(X_AUTH_SESSION_KEY);
  const xAccountId = localStorage.getItem(X_ACCOUNT_ID_KEY);

  if (xAuthSession) {
    request = request.clone({
      setHeaders: { [X_AUTH_SESSION_KEY]: xAuthSession },
    });
  }
  if (xAccountId) {
    request = request.clone({
      setHeaders: { [X_ACCOUNT_ID_KEY]: xAccountId },
    });
  }

  return next(request);
};
